(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ConversacionesController', ConversacionesController)

    ConversacionesController.$inject = ["ConversacionesService", "ContactService"];

    function ConversacionesController(ConversacionesService, ContactService) {
        var ic = this;

        ic.contactos = { loading: true, error: false, data: [] };
        ic.searchQuery = '';
        ic.selected = null;
        ic.hilo = { loading: false, error: false, mensajes: [] };
        ic.replyText = '';
        ic.replyNote = '';
        ic.replySending = false;

        ic.init = function () {
            ic.cargarContactos();
            ic.cargarEtiquetas();
        };

        // -- Filtro de la barra lateral, estilo bandeja de Gmail: 'todas',
        // 'pendientes', 'sin' (sin categoría) o 'etiqueta' (con etiquetaId).

        ic.filtro = { tipo: 'todas', etiquetaId: null };
        ic.etiquetas = { loading: true, error: false, data: [] };

        ic.cargarEtiquetas = function () {
            ic.etiquetas.loading = true;
            ic.etiquetas.error = false;

            return ConversacionesService.GetEtiquetas().then(function (data) {
                ic.etiquetas.data = data;
            }, function () {
                ic.etiquetas.error = 'No se han podido cargar las categorías.';
            }).finally(function () {
                ic.etiquetas.loading = false;
            });
        };

        ic.filtrar = function (tipo, etiqueta) {
            ic.filtro = { tipo: tipo, etiquetaId: etiqueta ? etiqueta.id : null };
        };

        ic.filtroActivo = function (tipo, etiqueta) {
            return ic.filtro.tipo === tipo && (!etiqueta || ic.filtro.etiquetaId === etiqueta.id);
        };

        function tieneEtiqueta(contacto, etiquetaId) {
            return (contacto.etiquetas || []).some(function (etiqueta) {
                return etiqueta.id === etiquetaId;
            });
        }

        function cumpleFiltro(contacto, tipo, etiquetaId) {
            switch (tipo) {
                case 'pendientes':
                    return contacto.pendientes > 0;
                case 'sin':
                    return !(contacto.etiquetas || []).length;
                case 'etiqueta':
                    return tieneEtiqueta(contacto, etiquetaId);
                default:
                    return true;
            }
        }

        // Predicado para el filter de ng-repeat de la lista.
        ic.coincideFiltro = function (contacto) {
            return cumpleFiltro(contacto, ic.filtro.tipo, ic.filtro.etiquetaId);
        };

        // Contador de la barra lateral: cuántos contactos entran en ese filtro.
        ic.contar = function (tipo, etiqueta) {
            return ic.contactos.data.filter(function (contacto) {
                return cumpleFiltro(contacto, tipo, etiqueta ? etiqueta.id : null);
            }).length;
        };

        ic.tituloFiltro = function () {
            switch (ic.filtro.tipo) {
                case 'pendientes':
                    return 'Pendientes';
                case 'sin':
                    return 'Sin categoría';
                case 'etiqueta':
                    var etiqueta = ic.etiquetas.data.filter(function (e) {
                        return e.id === ic.filtro.etiquetaId;
                    })[0];
                    return etiqueta ? etiqueta.nombre : 'Categoría';
                default:
                    return 'Todas las mías';
            }
        };

        // -- Nueva categoría (ConversationLabel).

        ic.COLORES_ETIQUETA = ['#4b41e1', '#4da5b1', '#26d51f', '#d0d031', '#f59e0b', '#ff1919', '#e91e63', '#9c27b0', '#607d8b'];
        ic.nuevaEtiqueta = null;

        ic.abrirNuevaEtiqueta = function () {
            ic.nuevaEtiqueta = {
                datos: { nombre: '', color: ic.COLORES_ETIQUETA[0], descripcion: '' },
                guardando: false,
                error: null,
            };
            getNuevaEtiquetaModal().show();
        };

        ic.enviarNuevaEtiqueta = function () {
            var ne = ic.nuevaEtiqueta;
            if (!ne || !(ne.datos.nombre || '').trim()) {
                return;
            }

            ne.guardando = true;
            ne.error = null;

            ConversacionesService.CrearEtiqueta(ne.datos).then(function (etiqueta) {
                getNuevaEtiquetaModal().hide();
                ic.cargarEtiquetas().then(function () {
                    ic.filtrar('etiqueta', etiqueta);
                });
            }, function (response) {
                ne.error = primerError(response) || 'No se ha podido guardar la categoría.';
            }).finally(function () {
                ne.guardando = false;
            });
        };

        // -- Lista negra de remitentes (EmailBlacklist): sus mensajes se
        // guardan, pero la IA no los procesa. Cada entrada bloquea un
        // dominio, un contacto o un distribuidor.

        ic.blacklist = { loading: false, error: null, data: [], nueva: null, guardando: false, quitandoId: null };

        function nuevaEntradaBlacklist(tipo) {
            return { tipo: tipo || 'dominio', domain: '', query: '', searching: false, resultados: [], elegido: null };
        }

        ic.abrirBlacklist = function (nueva) {
            ic.blacklist.nueva = nueva || nuevaEntradaBlacklist();
            ic.blacklist.error = null;
            ic.blacklist.loading = true;
            getBlacklistModal().show();

            ConversacionesService.GetBlacklist().then(function (data) {
                ic.blacklist.data = data;
            }, function () {
                ic.blacklist.error = 'No se ha podido cargar la lista negra.';
            }).finally(function () {
                ic.blacklist.loading = false;
            });
        };

        // Desde el hilo abierto: el contacto o, si aún no es contacto y la
        // dirección es un email, su dominio (se puede corregir antes de añadirlo).
        ic.bloquearSeleccionado = function () {
            var nueva;
            if (ic.selected.contactoId) {
                nueva = nuevaEntradaBlacklist('contacto');
                nueva.elegido = { id: ic.selected.contactoId, texto: ic.nombreCompleto(ic.selected), detalle: ic.selected.empresa || '' };
            } else {
                nueva = nuevaEntradaBlacklist('dominio');
                var direccion = ic.selected.direccion || '';
                if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(direccion) && !/@(c\.us|s\.whatsapp\.net|lid)$/i.test(direccion)) {
                    nueva.domain = direccion.replace(/^.*@/, '');
                }
            }
            ic.abrirBlacklist(nueva);
        };

        ic.cambiarTipoBlacklist = function (tipo) {
            ic.blacklist.nueva = nuevaEntradaBlacklist(tipo);
            ic.blacklist.error = null;
        };

        ic.buscarBlacklist = function () {
            var nueva = ic.blacklist.nueva;
            var query = (nueva.query || '').trim();
            if (!query) {
                nueva.resultados = [];
                return;
            }

            nueva.searching = true;
            var busqueda = nueva.tipo === 'contacto'
                ? ConversacionesService.BuscarContactos(query).then(function (data) {
                    return data.map(function (contacto) {
                        return { id: contacto.id, texto: ((contacto.nombre || '') + ' ' + (contacto.apellidos || '')).trim(), detalle: contacto.empresa || contacto.email || contacto.telefono || '' };
                    });
                })
                : ConversacionesService.BuscarDistribuidores(query).then(function (data) {
                    return data.map(function (distribuidor) {
                        return { id: distribuidor.id, texto: distribuidor.empresa || ('Distribuidor #' + distribuidor.id), detalle: distribuidor.email || '' };
                    });
                });

            busqueda.then(function (resultados) {
                // Solo si sigue siendo la misma búsqueda (el usuario puede haber seguido escribiendo).
                if (ic.blacklist.nueva === nueva && (nueva.query || '').trim() === query) {
                    nueva.resultados = resultados;
                }
            }, function () {
                nueva.resultados = [];
            }).finally(function () {
                nueva.searching = false;
            });
        };

        ic.elegirBlacklist = function (item) {
            ic.blacklist.nueva.elegido = item;
            ic.blacklist.nueva.resultados = [];
            ic.blacklist.nueva.query = '';
        };

        ic.puedeAgregarBlacklist = function () {
            var nueva = ic.blacklist.nueva;

            return !!nueva && !ic.blacklist.guardando && (nueva.tipo === 'dominio' ? !!(nueva.domain || '').trim() : !!nueva.elegido);
        };

        ic.agregarBlacklist = function () {
            if (!ic.puedeAgregarBlacklist()) {
                return;
            }

            var nueva = ic.blacklist.nueva;
            var datos = { tipo: nueva.tipo };
            if (nueva.tipo === 'dominio') {
                datos.domain = nueva.domain;
            } else if (nueva.tipo === 'contacto') {
                datos.contacto_id = nueva.elegido.id;
            } else {
                datos.distribuidor_id = nueva.elegido.id;
            }

            ic.blacklist.guardando = true;
            ic.blacklist.error = null;

            ConversacionesService.AgregarBlacklist(datos).then(function (data) {
                ic.blacklist.data = data;
                ic.blacklist.nueva = nuevaEntradaBlacklist(nueva.tipo);
            }, function (response) {
                ic.blacklist.error = primerError(response) || 'No se ha podido añadir a la lista negra.';
            }).finally(function () {
                ic.blacklist.guardando = false;
            });
        };

        ic.quitarBlacklist = function (entrada) {
            if (!window.confirm('¿Quitar «' + entrada.texto + '» de la lista negra? La IA volverá a procesar sus mensajes nuevos.')) {
                return;
            }

            ic.blacklist.quitandoId = entrada.id;
            ic.blacklist.error = null;

            ConversacionesService.QuitarBlacklist(entrada.id).then(function (data) {
                ic.blacklist.data = data;
            }, function (response) {
                ic.blacklist.error = primerError(response) || 'No se ha podido quitar de la lista negra.';
            }).finally(function () {
                ic.blacklist.quitandoId = null;
            });
        };

        ic.ICONOS_BLACKLIST = { dominio: 'alternate_email', contacto: 'person', distribuidor: 'store', vacia: 'help' };

        var blacklistModal = null;

        function getBlacklistModal() {
            if (!blacklistModal) {
                blacklistModal = new bootstrap.Modal(document.getElementById('conversacionesBlacklistModal'));
            }

            return blacklistModal;
        }

        var nuevaEtiquetaModal = null;

        function getNuevaEtiquetaModal() {
            if (!nuevaEtiquetaModal) {
                nuevaEtiquetaModal = new bootstrap.Modal(document.getElementById('conversacionesNuevaEtiquetaModal'));
            }

            return nuevaEtiquetaModal;
        }

        ic.cargarContactos = function () {
            ic.contactos = { loading: true, error: false, data: ic.contactos.data };

            return ConversacionesService.GetContactos().then(function (data) {
                ic.contactos.data = data;
            }, function () {
                ic.contactos.error = 'No se han podido cargar las conversaciones.';
            }).finally(function () {
                ic.contactos.loading = false;
            });
        };

        // Sin contacto, la conversación se identifica por la dirección de la otra parte.
        ic.nombreCompleto = function (contacto) {
            var nombre = ((contacto.nombre || '') + ' ' + (contacto.apellidos || '')).trim();

            return nombre || contacto.direccion || 'Contacto sin nombre';
        };

        // "salida" y "saliente" llegan las dos según de dónde venga el mensaje.
        ic.esSaliente = function (mensaje) {
            return mensaje.direccion === 'saliente' || mensaje.direccion === 'salida';
        };

        ic.iniciales = function (contacto) {
            return ic.nombreCompleto(contacto).split(' ').filter(function (parte) {
                return parte;
            }).slice(0, 2).map(function (parte) {
                return parte.charAt(0).toUpperCase();
            }).join('');
        };

        // MySQL manda "Y-m-d H:i:s" (espacio, no "T"): algunos navegadores
        // (Safari) no lo parsean como fecha válida si no se normaliza a ISO 8601.
        ic.formatFecha = function (fecha) {
            if (!fecha) {
                return '';
            }

            var date = new Date(String(fecha).replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return fecha;
            }

            return date.toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        };

        // Como en la bandeja de Gmail: la hora si es de hoy, si no el día y
        // el mes (y el año si no es el actual).
        ic.formatFechaCorta = function (fecha) {
            if (!fecha) {
                return '';
            }

            var date = new Date(String(fecha).replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return fecha;
            }

            var hoy = new Date();
            if (date.toDateString() === hoy.toDateString()) {
                return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
            }

            return date.toLocaleDateString('es-ES', date.getFullYear() === hoy.getFullYear()
                ? { day: 'numeric', month: 'short' }
                : { day: 'numeric', month: 'short', year: 'numeric' });
        };

        ic.abrirContacto = function (contacto) {
            ic.selected = contacto;
            ic.cargarHilo();
        };

        ic.cargarHilo = function () {
            ic.hilo = { loading: true, error: false, mensajes: [] };
            ic.replyText = '';
            ic.replyNote = '';

            ConversacionesService.GetHilo(ic.selected.contactoId, ic.selected.direccion).then(function (data) {
                ic.hilo.mensajes = data;
            }, function () {
                ic.hilo.error = 'No se ha podido cargar la conversación.';
            }).finally(function () {
                ic.hilo.loading = false;
            });
        };

        // Envuelve el texto seleccionado del textarea de respuesta con el
        // marcador dado. WhatsApp interpreta *texto* como negrita y _texto_
        // como cursiva, así que estos botones producen formato real, no solo
        // cosmético, en ese canal (en el resto simplemente se envían los
        // asteriscos/guiones bajos como texto plano).
        ic.formatReply = function (marker) {
            var textarea = document.getElementById('conversacionesReplyText');
            if (!textarea) {
                return;
            }

            var start = textarea.selectionStart || 0;
            var end = textarea.selectionEnd || 0;
            var text = ic.replyText || '';
            var selected = text.slice(start, end) || 'texto';

            ic.replyText = text.slice(0, start) + marker + selected + marker + text.slice(end);

            setTimeout(function () {
                textarea.focus();
                textarea.setSelectionRange(start + marker.length, start + marker.length + selected.length);
            });
        };

        ic.discardReply = function () {
            ic.replyText = '';
            ic.replyNote = '';
        };

        // Responde siempre al último mensaje del hilo (misma lógica que
        // ContactoController::actionResponder(), independiente del canal o de
        // conversacion_id de ese mensaje): tras enviar, se recarga el hilo
        // entero en vez de empujar la respuesta a mano, porque
        // ContactService.Responder() no devuelve channelIcon/channelColor
        // (los añade ConversacionesController::actionGethilo() al leer).
        ic.enviarRespuesta = function () {
            var texto = (ic.replyText || '').trim();
            var ultimo = ic.hilo.mensajes.length ? ic.hilo.mensajes[ic.hilo.mensajes.length - 1] : null;

            if (!texto || !ultimo) {
                return;
            }

            ic.replySending = true;

            ContactService.Responder(ultimo.id, texto, ic.replyNote).then(function () {
                ic.cargarHilo();
                ic.cargarContactos();
            }, function (response) {
                ic.hilo.error = (response && response.msg) || 'No se ha podido enviar la respuesta.';
            }).finally(function () {
                ic.replySending = false;
            });
        };

        // -- Nueva conversación: primero se busca/elige el contacto (acá no hay
        // ninguno todavía en contexto, a diferencia de contacto.twig), y recién
        // después se elige canal y se escribe el primer mensaje, igual que
        // ContactoController.abrirNuevaConversacion().

        ic.nuevaConversacion = nuevaConversacionVacia();

        function nuevaConversacionVacia() {
            return {
                loading: false,
                error: false,
                query: '',
                searching: false,
                resultados: [],
                contacto: null,
                canales: [],
                selectedCanal: null,
                titulo: '',
                texto: '',
                enviando: false,
            };
        }

        ic.abrirNuevaConversacion = function () {
            ic.nuevaConversacion = nuevaConversacionVacia();
            getNewConversationModal().show();
        };

        ic.buscarContactosNuevaConversacion = function () {
            var query = (ic.nuevaConversacion.query || '').trim();
            if (!query) {
                ic.nuevaConversacion.resultados = [];
                return;
            }

            ic.nuevaConversacion.searching = true;

            ConversacionesService.BuscarContactos(query).then(function (data) {
                ic.nuevaConversacion.resultados = data;
            }, function () {
                ic.nuevaConversacion.resultados = [];
            }).finally(function () {
                ic.nuevaConversacion.searching = false;
            });
        };

        ic.elegirContactoNuevaConversacion = function (contacto) {
            ic.nuevaConversacion.contacto = contacto;
            ic.nuevaConversacion.loading = true;
            ic.nuevaConversacion.canales = [];
            ic.nuevaConversacion.error = false;

            ContactService.CanalesDisponibles(contacto.id).then(function (data) {
                ic.nuevaConversacion.canales = data;
            }, function () {
                ic.nuevaConversacion.error = 'No se han podido cargar tus canales conectados.';
            }).finally(function () {
                ic.nuevaConversacion.loading = false;
            });
        };

        ic.cambiarContactoNuevaConversacion = function () {
            ic.nuevaConversacion.contacto = null;
            ic.nuevaConversacion.canales = [];
            ic.nuevaConversacion.selectedCanal = null;
        };

        ic.seleccionarCanalNuevaConversacion = function (canal) {
            if (!canal.puedeEnviar) {
                return;
            }

            ic.nuevaConversacion.selectedCanal = canal;
        };

        ic.enviarNuevaConversacion = function () {
            var nc = ic.nuevaConversacion;
            var texto = (nc.texto || '').trim();
            var titulo = (nc.titulo || '').trim();

            if (!texto || !titulo || !nc.selectedCanal || !nc.contacto) {
                return;
            }

            nc.enviando = true;

            ContactService.IniciarConversacion(nc.contacto.id, nc.selectedCanal.id, texto, titulo).then(function () {
                getNewConversationModal().hide();
                ic.cargarContactos();
                ic.abrirContacto({
                    clave: 'c' + nc.contacto.id,
                    contactoId: nc.contacto.id,
                    nombre: nc.contacto.nombre,
                    apellidos: nc.contacto.apellidos,
                    empresa: nc.contacto.empresa,
                    image: null,
                });
            }, function (response) {
                nc.error = (response && response.msg) || 'No se ha podido enviar el mensaje.';
            }).finally(function () {
                nc.enviando = false;
            });
        };

        // -- Guardar como contacto: para una conversación sin contacto. Se
        // rellena el email o el teléfono con la dirección de la otra parte.

        ic.guardarContacto = null;

        ic.abrirGuardarContacto = function () {
            var direccion = ic.selected.direccion || '';
            // Los ids de WhatsApp (34600111222@c.us) también llevan "@".
            var esWhatsapp = /@(c\.us|s\.whatsapp\.net|lid)$/i.test(direccion);
            var esEmail = !esWhatsapp && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(direccion);

            ic.guardarContacto = {
                datos: {
                    nombre: '',
                    apellidos: '',
                    empresa: '',
                    email: esEmail ? direccion : '',
                    telefono: esEmail ? '' : direccion.replace(/@.*$/, ''),
                },
                guardando: false,
                error: null,
            };
            getGuardarContactoModal().show();
        };

        ic.enviarGuardarContacto = function () {
            var gc = ic.guardarContacto;
            if (!gc || !(gc.datos.nombre || '').trim()) {
                return;
            }

            gc.guardando = true;
            gc.error = null;

            ConversacionesService.CrearContacto(ic.selected.direccion, gc.datos).then(function (data) {
                getGuardarContactoModal().hide();
                ic.cargarContactos().then(function () {
                    var nuevo = ic.contactos.data.filter(function (contacto) {
                        return contacto.clave === data.clave;
                    })[0];
                    if (nuevo) {
                        ic.abrirContacto(nuevo);
                    }
                });
            }, function (response) {
                gc.error = primerError(response) || 'No se ha podido guardar el contacto.';
            }).finally(function () {
                gc.guardando = false;
            });
        };

        function primerError(response) {
            if (!response) {
                return null;
            }
            if (response.msg) {
                return response.msg;
            }
            var errores = response.errors || {};
            for (var campo in errores) {
                if (errores[campo] && errores[campo].length) {
                    return errores[campo][0];
                }
            }
            return null;
        }

        var guardarContactoModal = null;

        function getGuardarContactoModal() {
            if (!guardarContactoModal) {
                guardarContactoModal = new bootstrap.Modal(document.getElementById('conversacionesGuardarContactoModal'));
            }

            return guardarContactoModal;
        }

        var newConversationModal = null;

        function getNewConversationModal() {
            if (!newConversationModal) {
                newConversationModal = new bootstrap.Modal(document.getElementById('conversacionesNewModal'));
            }

            return newConversationModal;
        }
    }
})();
